import React, { Fragment, useEffect, useState } from "react";
import { Alert, Backdrop, CircularProgress, Container } from "@mui/material";
import PaymentEft from "../../components/PaymentEft";
import {
	ApiCallStatus,
	PaymentMethod, PaymentType
} from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import {
	createEftPaymentData,
	fetchPaymentOrderData
} from "../PageFunctions/paymentFunctions";
import { useArgusAuth } from "../../hooks/useArgusAuth";


const PaymentEftPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [paymentOrderInfo, setPaymentOrderInfo] = useState(null);
	const [paymentErrorMessage, setPaymentErrorMessage] = useState("");

	const [paymentOrderInfoCallStatus, setPaymentOrderInfoCallStatus] = useState(ApiCallStatus.NotStarted);
	const [createEftPaymentCallStatus, setCreateEftPaymentCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => navigate("/login", {state: {from: location}});
	const gotoOrderConfirmationPage = (orderId) => navigate(`/order-confirmation/${orderId}`);


	const fetchPaymentOrderDataAsync = async () => {
		await fetchPaymentOrderData({
			paymentType: PaymentType.EFT,
			setPaymentOrderInfo,
			setStatusInProgress: () => setPaymentOrderInfoCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setPaymentOrderInfoCallStatus(ApiCallStatus.Error)
		});
	};

	const createEftPaymentDataAsync = async () => {
		setPaymentErrorMessage("");
		await createEftPaymentData({
			setStatusInProgress: () => setCreateEftPaymentCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setCreateEftPaymentCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setCreateEftPaymentCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setCreateEftPaymentCallStatus(ApiCallStatus.Error),
			setErrorMessage: setPaymentErrorMessage
		});
	};

	const authorizedPageLoad = async () => {

	};

	const unAuthorizedPageLoad = async () => {
		await fetchPaymentOrderDataAsync();
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			} else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		if (createEftPaymentCallStatus === ApiCallStatus.Succeeded && !!paymentOrderInfo?.orderId) {
			gotoOrderConfirmationPage(paymentOrderInfo.orderId);
		}
	}, [createEftPaymentCallStatus, paymentOrderInfo]);

	useEffect(() => {
		// if (!!paymentErrorMessage) window.scrollTo(0, 0);
	}, [paymentErrorMessage]);

	const allLoadingStates = [
		paymentOrderInfoCallStatus,
		createEftPaymentCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			{!!paymentErrorMessage && (
				<Alert severity="warning" sx={{mt: 2, mb: 2}}>
					{paymentErrorMessage}
				</Alert>
			)}
			<PaymentEft
				paymentOrderInfo={paymentOrderInfo}
				onSubmit={createEftPaymentDataAsync}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};

export default PaymentEftPage;
